import { render, staticRenderFns } from "./paymentAgreement.vue?vue&type=template&id=ca5dd550&scoped=true"
import script from "./paymentAgreement.vue?vue&type=script&lang=js"
export * from "./paymentAgreement.vue?vue&type=script&lang=js"
import style0 from "./paymentAgreement.vue?vue&type=style&index=0&id=ca5dd550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5dd550",
  null
  
)

export default component.exports